import { ACTIONS_PLAYER } from "../actions/player-pitchers";
import { ACTIONS_SEARCH } from './../actions/player-search';
import { ACTIONS_MASTER } from './../actions/master';
export default (state = {}, action) => {
    switch (action.type) {
        case ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_SUCCESS:
        case ACTIONS_SEARCH.GET_PLAYER_SUCCESS: 
        case ACTIONS_SEARCH.GET_INFO_PLAYER_SUCCESS:        
        case ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_SUCCESS:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_SUCCESS:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_HOTZONE_SUCCESS:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_ERROR:
        case ACTIONS_SEARCH.GET_PLAYER_ERROR: 
        case ACTIONS_SEARCH.GET_INFO_PLAYER_ERROR:  
        case ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_ERROR:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_ERROR:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_HOTZONE_ERROR:
        case ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        case ACTIONS_MASTER.GET_YEAR_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data
            };
        default:
            return state;
    }
};